import { createContext } from "react";
import { AdminData } from "@/interfaces";

export interface IsAdminModeContextProps {
  isAdminMode: boolean;
  setIsAdminMode: (isAdminMode: boolean) => void;
  currentAdminData: AdminData | undefined;
  setCurrentAdminData: (adminData?: AdminData) => void;
}

export const IsAdminModeContext = createContext<IsAdminModeContextProps>({
  isAdminMode: false,
  setIsAdminMode: () => undefined,
  currentAdminData: undefined,
  setCurrentAdminData: () => undefined,
});
